var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('router-link',{attrs:{"to":{
        name: 'single-customer-group',
        params: { id: _vm.props.item.id }
      }}},[_vm._v("\n      "+_vm._s(_vm.props.item.code)+"\n    ")])],1),_c('td',{staticClass:"text-xs-left"},[_vm._v("\n    "+_vm._s(_vm.props.item.name)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }